<template>
  <div class="container" @click="goToHome">
    
    <div class="content">
      <img class="gelatine" src="@/assets/logo-dcp.png" />
    </div>
    <div class="footer">
      Made by Des Choses Pareilles - Version {{ $store.state.packageVersion }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      files: [],
      currentIndex: 0,
    };
  },
  mounted() {
    this.fetchFiles();
  },
  methods: {
    async fetchFiles() {
      try {
        const response = await fetch(this.contentUrl);
        const text = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, "text/html");
        const links = Array.from(doc.querySelectorAll("a"))
          .map((a) => a.innerText)
          .filter((href) => href.match(/\.(mp4|jpg|png|jpeg)$/i)); // Filtre les images et vidéos

        this.files = links;

        if (this.files.length === 0) {
          console.warn("Aucun fichier trouvé.");
        } else {
          console.log(this.files);
          this.startSlideshow();
        }
      } catch (error) {
        console.error("Erreur lors de la récupération des fichiers :", error);
      }
    },
    startSlideshow() {
      if (this.files.length > 0) {
        this.currentIndex = 0;
      }
    },
    nextFile() {
      this.currentIndex = (this.currentIndex + 1) % this.files.length;
    },
    startImageTimer() {
      setTimeout(this.nextFile, 5000);
    },
    goToHome() {
      this.$router.push({ name: "home" });
    }
  }
};

import "@/styles/animations/gelatine.scss"

</script>

<style lang="scss" scoped>
.container {
  background: $primary-color;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.media-container {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

img {
  width: 60vw;
  max-width: 60vh;
}

.fullscreen-video,
.fullscreen-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.no-content-message {
  font-size: 1.5rem;
  color: white;
  text-align: center;
  padding: 20px;
}

.footer {
  position: absolute;
  bottom: 10px;
  width: 100%;
  text-align: center;
  color: white;
}
</style>
